<script lang="ts" setup>
import { ref, toRefs } from 'vue';
import { InputNumberInputEvent } from 'primevue/inputnumber';
import { useProgressReportDropdown } from '@/composables';

interface Props {
  goalId: undefined | number;
}

const props = withDefaults(defineProps<Props>(), { goalId: undefined });

const { goalId } = toRefs(props);

const quantity = ref();

const onInput = (event: InputNumberInputEvent) => useProgressReportDropdown(goalId, 'quantity').onChange(event);
</script>

<template><InputNumber v-model="quantity" placeholder="Quantity" @input="onInput" /></template>
